module.exports = __webpack_public_path__ + "img/product2.2437c5c.png";